import classNames from 'classnames';
import PropTypes from 'prop-types';
import React from 'react';

import styles from './index.module.scss';

const blockName = 'dimmable';

export const Dimmable = ({ children, active }) => (
  <div
    data-testid="dimmable"
    className={classNames(styles[blockName], {
      [styles[`${blockName}--active`]]: active,
    })}
  >
    {active && (
      <div data-testid="overlay" className={styles[`${blockName}-overlay`]} />
    )}

    <div
      className={classNames(styles[`${blockName}-children`], {
        [styles[`${blockName}-promoted`]]: active,
      })}
    >
      {children}
    </div>
  </div>
);

Dimmable.defaultProp = {
  children: '',
};

Dimmable.propTypes = {
  children: PropTypes.oneOfType([
    PropTypes.arrayOf(PropTypes.node),
    PropTypes.node,
  ]).isRequired,
  active: PropTypes.bool,
};
